import React, { useEffect, useState } from "react";
import { bool, string, object, func } from "prop-types";
import AnimateHeight from "react-animate-height";
import YouTubeVideo from "../../components/YouTubeVideo/YouTubeVideoApp.jsx";
import cx from "classnames";
import uniqueId from "lodash.uniqueid";

const propTypes = {
  isOpen: bool.isRequired,
  handleItemClick: func.isRequired,
  title: string.isRequired,
  description: string,
  video: object,
};

const SlideshowItem = (props) => {
  const { isOpen, handleItemClick, title, description, video } = props;

  const [isMobile, setIsMobile] = useState(false);
  const id = uniqueId("mc-slide-");

  const determineMobile = () => {
    window.innerWidth >= 781 ? setIsMobile(false) : setIsMobile(true);
  };

  useEffect(() => {
    determineMobile();
    window.addEventListener("resize", determineMobile);
    return () => window.removeEventListener("resize", determineMobile);
  }, []);

  const calculateHeight = (isOpen, isMobile) => {
    return isOpen ? (isMobile ? "auto" : 400) : 0;
  };

  let posterImage;
  if (video.poster) {
    posterImage = {
      alt: video.poster.alt,
      srcSet: [
        [video.poster.small, "480w"],
        [video.poster.medium, "680w"],
        [video.poster.large, "1292w"],
      ]
        .filter(([imageUrl]) => typeof imageUrl === "string")
        .map(([imageUrl, imageSize]) => {
          return `${imageUrl} ${imageSize}`;
        })
        .join(","),
      sizes: "300px",
    };
  }

  return (
    <div
      className={cx("multi-content-slideshow__item", {
        "multi-content-slideshow__item--active": isOpen,
      })}
    >
      <button
        className="btn multi-content-slideshow__item-button"
        onClick={handleItemClick}
        type="button"
        aria-expanded={isOpen}
        disabled={isOpen}
        aria-controls={id}
      >
        {title}
      </button>
      <AnimateHeight
        id={id}
        className="multi-content-slideshow__contents"
        height={calculateHeight(isOpen, isMobile)}
        duration={500}
      >
        <div className="multi-content-slideshow__description">
          {description}
        </div>
        {isMobile && video.id && isOpen && (
          <div className="multi-content-slideshow__mobile-video-container">
            <YouTubeVideo {...video} image={posterImage} />
          </div>
        )}
        {isMobile && !video.id && (
          <img
            className="multi-content-slideshow__mobile-img"
            alt={video.poster.alt}
            srcSet={`${video.poster.small} 480w, ${video.poster.medium} 680w, ${video.poster.large} 1292w`}
            sizes="300px"
          />
        )}
      </AnimateHeight>
    </div>
  );
};

SlideshowItem.propTypes = propTypes;
export default SlideshowItem;
